import {
    ADICIONAR_FILTRO_ITINERARIO_EMBARQUE,
    LIMPAR_FILTRO_ITINERARIO_EMBARQUE,
    LISTAR_FILTROS_ITINERARIO_EMBARQUE,
    REMOVER_FILTRO_ITINERARIO_EMBARQUE
  } from '../../actions/types'
  import { filtroExiste } from '../../util/filtros'
  
  const initialState = undefined
  
  const initial = {
  }
  
  export const filtrosAdicionadosItinerarioEmbarque = (state = [], action = initialState) => {
    switch (action.type) {
      case ADICIONAR_FILTRO_ITINERARIO_EMBARQUE: {
        if (!filtroExiste(state, action.payload)) {
          return state.concat(action.payload)
        }
        return state
      }
  
      case REMOVER_FILTRO_ITINERARIO_EMBARQUE: {
        const copia = [...state]
        return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
      }
  
      case LIMPAR_FILTRO_ITINERARIO_EMBARQUE: {
        return []
      }
  
      default:
        return state
    }
  }
  
  export const filtrosItinerarioEmbarque = (state = initial, action) => {
    switch (action.type) {
      case LISTAR_FILTROS_ITINERARIO_EMBARQUE: {
        const retorno = action.payload.data;
        if(retorno){
          return retorno
        }
        return initialState
      }
      default:
        return state
    }
  }
  